import { render, staticRenderFns } from "./ControlCambios.vue?vue&type=template&id=3143acd0&scoped=true"
import script from "./ControlCambios.vue?vue&type=script&lang=js"
export * from "./ControlCambios.vue?vue&type=script&lang=js"
import style0 from "./ControlCambios.vue?vue&type=style&index=0&id=3143acd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3143acd0",
  null
  
)

export default component.exports